/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const financialsKeyContractDtoSchema = z.object({
  name: z.optional(z.string()),
  accent: z.optional(z.string()),
  points: z.optional(z.array(z.string())),
});
